import React, { useState, useEffect } from 'react';
import api from '../Api/api';
import { Layout, DatePicker, Button, Typography, Divider, Empty } from 'antd';
import { saveAs } from 'file-saver';

import TitleAndNew from '../Components/TitleAndNew/TitleAndNew';
import AllUsersStatsTable from '../Components/Table/AllUsersStatsTable';

const { Content } = Layout;
const { MonthPicker, RangePicker } = DatePicker;
const { Title } = Typography;

const AdminReports = () => {
  // const [date, setDate] = useState('');
  // const [dateRange, setDateRange] = useState(['', '']);
  // const handleDateChange = (date, dateString) => {
  //   setDate(dateString);
  // };
  // const handleRangeChange = (date, dateString) => {
  //   setDateRange(dateString);
  // };

  // const handleDownloadMonthReport = async () => {
  //   const response = await api.getMonthReport(date);
  //   saveAs(
  //     // eslint-disable-next-line no-undef
  //     new Blob([response.data], { type: 'application/octet-stream' }),
  //     `report-${date}.xlsx`
  //   );
  // };

  // const handleDownloadCustomReport = async () => {
  //   const response = await api.getCustomReport(dateRange);
  //   saveAs(
  //     // eslint-disable-next-line no-undef
  //     new Blob([response.data], { type: 'application/octet-stream' }),
  //     `report-${date}.xlsx`
  //   );
  // };

  return (
    <Layout>
      <Content style={{ margin: '36px' }}>
        <TitleAndNew titleText={'Raporty'} />
        <div
          style={{
            background: '#fff',
            padding: '16px',
            borderRadius: '8px',
          }}
        >
          {/*<div*/}
          {/*  style={{*/}
          {/*    padding: '16px'*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Title level={4}>Raport miesięczny</Title>*/}
          {/*  <MonthPicker*/}
          {/*    onChange={handleDateChange}*/}
          {/*    placeholder="Wybierz miesiąc"*/}
          {/*    style={{ marginRight: '24px' }}*/}
          {/*  />*/}
          {/*  <Button*/}
          {/*    onClick={handleDownloadMonthReport}*/}
          {/*    type="primary"*/}
          {/*    icon="download"*/}
          {/*    disabled={!date}*/}
          {/*  >*/}
          {/*    Pobierz*/}
          {/*  </Button>*/}
          {/*</div>*/}
          {/*<div*/}
          {/*  style={{*/}
          {/*    padding: '16px'*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Title level={4}>Wygeneruj raport </Title>*/}
          {/*  <RangePicker*/}
          {/*    placeholder={['Od', 'Do']}*/}
          {/*    format="YYYY-MM-DD"*/}
          {/*    onChange={handleRangeChange}*/}
          {/*    style={{ marginRight: '24px' }}*/}
          {/*  />*/}
          {/*  <Button*/}
          {/*    onClick={handleDownloadCustomReport}*/}
          {/*    type="primary"*/}
          {/*    icon="download"*/}
          {/*    disabled={!dateRange[0].length > 0}*/}
          {/*  >*/}
          {/*    Pobierz*/}
          {/*  </Button>*/}
          {/*</div>*/}
          {/*<Divider />*/}
          <div
            style={{
              padding: '16px',
            }}
          >
            <Title level={4}>Statystyki użytkowników</Title>

            <AllUsersStatsTable />

            <Divider />

            <Title level={4}>Statystyki projektów</Title>
            <Empty description={<span>W przygotowaniu</span>} />
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default AdminReports;
